<template>
  <div class="products-page">
    <!-- Hero Section -->
    <section class="hero">
      <div class="hero-image">
        <img src="@/assets/images/ambience/data.jpg" alt="Hero background" />
      </div>
      <div class="hero-content">
        <h1>{{ $t('productsPage.hero.title') }}</h1>
        <h2>{{ $t('productsPage.hero.subtitle') }}</h2>
        <p class="description">
          {{ $t('productsPage.hero.description') }}
        </p>
      </div>
    </section>

    <!-- Forecast Section -->
    <section id="forecast" class="product-section">
      <h2>{{ $t('productsPage.forecast.title') }}</h2>
      <div class="product-content">
        <div class="product-description">
          <p class="lead-text">
            {{ $t('productsPage.forecast.leadText') }}
          </p>
          
          <div class="features">
            <h3>{{ $t('productsPage.forecast.featuresTitle') }}</h3>
            <ul>
              <li>
                <strong>{{ $t('productsPage.forecast.feature1Title') }}</strong>
                <p>{{ $t('productsPage.forecast.feature1Text') }}</p>
              </li>
              <li>
                <strong>{{ $t('productsPage.forecast.feature2Title') }}</strong>
                <p>{{ $t('productsPage.forecast.feature2Text') }}</p>
              </li>
              <li>
                <strong>{{ $t('productsPage.forecast.feature3Title') }}</strong>
                <p>{{ $t('productsPage.forecast.feature3Text') }}</p>
              </li>
            </ul>
          </div>

          <div class="use-cases">
            <h3>{{ $t('productsPage.forecast.useCasesTitle') }}</h3>
            <p>
              {{ $t('productsPage.forecast.useCasesText') }}
            </p>
          </div>
          <div class="feedback-section">
            <h4>{{ $t('productsPage.forecast.feedbackTitle') }}</h4>
            <p>
              {{ $t('productsPage.forecast.feedbackText') }}
            </p>
            <div>
              <TextWithArrowButton 
                :text="$t('productsPage.forecast.feedbackButton')" 
                @click="$router.push({ path: '/kontakt', query: { subject: 'Feedback om forecast-system' }})"
              />
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Vagtplanlægning Section -->
    <section id="vagtplanlaegning" class="product-section">
      <h2>{{ $t('productsPage.scheduling.title') }}</h2>
      <div class="product-content">
        <div class="product-description">
          <p class="lead-text">
            {{ $t('productsPage.scheduling.leadText') }}
          </p>

          <div class="features">
            <h3>{{ $t('productsPage.scheduling.featuresTitle') }}</h3>
            <ul>
              <li>
                <strong>{{ $t('productsPage.scheduling.feature1Title') }}</strong>
                <p>{{ $t('productsPage.scheduling.feature1Text') }}</p>
              </li>
              <li>
                <strong>{{ $t('productsPage.scheduling.feature2Title') }}</strong>
                <p>{{ $t('productsPage.scheduling.feature2Text') }}</p>
              </li>
              <li>
                <strong>{{ $t('productsPage.scheduling.feature3Title') }}</strong>
                <p>{{ $t('productsPage.scheduling.feature3Text') }}</p>
              </li>
            </ul>
          </div>


          <div class="use-cases">
            <h3>{{ $t('productsPage.scheduling.useCasesTitle') }}</h3>
            <p>
              {{ $t('productsPage.scheduling.useCasesText') }}
            </p>
          </div>
          <div class="feedback-section">
            <h4>{{ $t('productsPage.scheduling.feedbackTitle') }}</h4>
            <p>
              {{ $t('productsPage.scheduling.feedbackText') }}
            </p>
            <div>
              <TextWithArrowButton 
                :text="$t('productsPage.scheduling.feedbackButton')" 
                @click="$router.push({ path: '/kontakt', query: { subject: 'Feedback om vagtplanlægning' }})"
              />
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Kundeanmeldelser Section -->
    <section id="kundeanmeldelser" class="product-section">
      <h2>{{ $t('productsPage.reviews.title') }}</h2>
      <div class="product-content">
        <div class="product-description">
          <p class="lead-text">
            {{ $t('productsPage.reviews.leadText') }}
          </p>

          <div class="features">
            <h3>{{ $t('productsPage.reviews.featuresTitle') }}</h3>
            <ul>
              <li>
                <strong>{{ $t('productsPage.reviews.feature1Title') }}</strong>
                <p>{{ $t('productsPage.reviews.feature1Text') }}</p>
              </li>
              <li>
                <strong>{{ $t('productsPage.reviews.feature2Title') }}</strong>
                <p>{{ $t('productsPage.reviews.feature2Text') }}</p>
              </li>
              <li>
                <strong>{{ $t('productsPage.reviews.feature3Title') }}</strong>
                <p>{{ $t('productsPage.reviews.feature3Text') }}</p>
              </li>
              <li>
                <strong>{{ $t('productsPage.reviews.feature4Title') }}</strong>
                <p>{{ $t('productsPage.reviews.feature4Text') }}</p>
              </li>
            </ul>
          </div>

          <div class="use-cases">
            <h3>{{ $t('productsPage.reviews.useCasesTitle') }}</h3>
            <p>
              {{ $t('productsPage.reviews.useCasesText') }}
            </p>
          </div>
          <div class="feedback-section">
            <h4>{{ $t('productsPage.reviews.feedbackTitle') }}</h4>
            <p>
              {{ $t('productsPage.reviews.feedbackText') }}
            </p>
            <div>
              <TextWithArrowButton 
                :text="$t('productsPage.reviews.feedbackButton')" 
                @click="$router.push({ path: '/kontakt', query: { subject: 'Feedback om kundefeedback-system' }})"
              />
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Rapporter Section -->
    <section id="rapporter" class="product-section">
      <h2>{{ $t('productsPage.reports.title') }}</h2>
      <div class="product-content">
        <div class="product-description">
          <p class="lead-text">
            {{ $t('productsPage.reports.leadText') }}
          </p>

          <div class="features">
            <h3>{{ $t('productsPage.reports.featuresTitle') }}</h3>
            <ul>
              <li>
                <strong>{{ $t('productsPage.reports.feature1Title') }}</strong>
                <p>{{ $t('productsPage.reports.feature1Text') }}</p>
              </li>
              <li>
                <strong>{{ $t('productsPage.reports.feature2Title') }}</strong>
                <p>{{ $t('productsPage.reports.feature2Text') }}</p>
              </li>
              <li>
                <strong>{{ $t('productsPage.reports.feature3Title') }}</strong>
                <p>{{ $t('productsPage.reports.feature3Text') }}</p>
              </li>
              <li>
                <strong>{{ $t('productsPage.reports.feature4Title') }}</strong>
                <p>{{ $t('productsPage.reports.feature4Text') }}</p>
              </li>
            </ul>
          </div>

          <div class="use-cases">
            <h3>{{ $t('productsPage.reports.useCasesTitle') }}</h3>
            <p>
             {{ $t('productsPage.reports.useCasesText') }}
            </p>
          </div>
          <div class="feedback-section">
            <h4>{{ $t('productsPage.reports.feedbackTitle') }}</h4>
            <p>
              {{ $t('productsPage.reports.feedbackText') }}
            </p>
            <div class="feedback-cta">
              <TextWithArrowButton 
                :text="$t('productsPage.reports.feedbackButton')" 
                @click="$router.push({ path: '/kontakt', query: { subject: 'Feedback om rapporter og analyser' }})"
              />
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- CTA Section -->
    <section class="cta-section">
      <h2>{{ $t('productsPage.finalCta.title') }}</h2>
      <p>
        {{ $t('productsPage.finalCta.text') }}
      </p>
      <div class="hero-cta">
        <TextWithArrowButton :text="$t('productsPage.finalCta.button')" @click="$router.push('/kontakt', { query: { subject: 'Book møde/opkald' }})" />
      </div>
    </section>
  </div>
</template>

<script>
import { useI18n } from 'vue-i18n'
import TextWithArrowButton from '@/components/TextWithArrowButton.vue'
import '@/assets/logged-out.css'

export default {
  name: 'ProductPage',
  components: {
    TextWithArrowButton
  },
  setup() {
    const { t } = useI18n()
    return { t }
  }
}
</script>

<style scoped>
.hero {
  position: relative;
  padding: 12rem 2rem;
  width: 100%;
  margin-left: -1.5rem;
  margin-top: -1.7rem;
  text-align: center;
  overflow: hidden;
}

.hero-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}

.hero-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.hero-image::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, var(--dark-red-element) 0%, rgba(255, 255, 255, 0.9) 100%);
}

.hero-content {
  position: relative;
  z-index: 2;
}

.hero h1 {
  font-size: 2.5rem;
  color: var(--white);
  margin-bottom: 2rem;
  opacity: 0.1;
}

.hero h2 {
  font-size: 1.5rem;
  color: var(--white);
  margin-bottom: 1rem;
}

.hero .description {
  max-width: 800px;
  font-size: 1.2rem;
  font-weight: 500;
  margin: 0 auto;
  color: var(--white);
}

.product-nav {
  position: sticky;
  top: 80px;
  background: var(--white);
  padding: 1rem;
  display: flex;
  justify-content: center;
  gap: 2rem;
  border-bottom: 1px solid var(--border-color);
  z-index: 100;
}

.product-nav a {
  color: var(--primary-text-color);
  text-decoration: none;
  padding: 0.5rem 1rem;
}

.product-nav a:hover {
  color: var(--primary-color);
}

.product-section {
  padding: 4rem 2rem;
  max-width: 1200px;
  margin: 0 auto;
  scroll-margin-top: 100px;
}

.product-section:nth-child(odd) {
  background: var(--light-background);
}

.product-section h2 {
  font-size: 2.5rem;
  color: var(--primary-text-color);
  margin-bottom: 2rem;
}

.product-section p {
  font-size: 1.5rem;
  color: var(--secondary-text-color);
  margin-bottom: 2rem;
  line-height: 1.2;
}

.product-section h3 {
  font-size: 1.8rem;
  color: var(--secondary-text-color);
  margin-bottom: 2rem;
  line-height: 1.6;
}

.lead-text {
  font-size: 1.5rem;
  color: var(--secondary-text-color);
  margin-bottom: 2rem;
  line-height: 1.6;
}

.features {
  margin: 3rem 0;
}

.features ul {
  list-style: none;
  padding: 0;
}

.features li {
  margin-bottom: 2rem;
}

.features li strong {
  display: block;
  color: var(--primary-text-color);
  font-size: 1.5rem;
  margin-bottom: 0.5rem;
}

.use-cases {
  padding: 2rem;
  border-radius: 8px;
  margin: 3rem 0;
}

/* Different gradients for each section */
#forecast .use-cases {
  background: linear-gradient(5deg, var(--logged-out-stand-out-green) 0%, var(--white) 100%);
}

#vagtplanlaegning .use-cases {
  background: linear-gradient(270deg, var(--logged-out-stand-out-green) 0%, var(--white) 100%);
}

#kundeanmeldelser .use-cases {
  background: linear-gradient(178deg, var(--logged-out-stand-out-green) 0%, var(--white) 100%);   
}   

#rapporter .use-cases {
  background: linear-gradient(350deg, var(--logged-out-stand-out-green) 0%, var(--white) 100%);
}

.cta-section {
  text-align: center;
  padding: 4rem 2rem;
  background: var(--dark-red-element);
  color: var(--white);
}

.cta-section h2 {
  margin-bottom: 1rem;
}

.cta-section p {
  margin-bottom: 2rem;
}

.feedback-section {
  margin: 4rem 0;
}

.feedback-cta {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}


@media (max-width: 768px) {

  .product-nav {
    flex-wrap: wrap;
    gap: 1rem;
  }
  
  .product-section {
    padding: 2rem 1rem;
  }
  .hero {
    padding: 6rem 1rem 4rem 1.5rem;
  }
}

html {
  scroll-behavior: smooth;
}
</style> 